import { useTranslation } from 'react-i18next';
import useSettings from './useSettings';

const LANGS = [
  {
    label: 'Português',
    value: 'pt-BR',
    icon: '🇧🇷',
  },
  {
    label: 'English',
    value: 'en',
    icon: '🇺🇸',
  },
];

export default function useLocales() {
  const { i18n, t } = useTranslation();
  const { onChangeLanguage } = useSettings();

  const currentLang = LANGS.find((lang) => lang.value === i18n.language) || LANGS[0];

  const onChangeLang = (newLang) => {
    i18n.changeLanguage(newLang);
    onChangeLanguage(newLang);
  };

  return {
    t,
    i18n,
    currentLang,
    allLangs: LANGS,
    onChangeLang,
  };
}
